import { ColorDynamic } from '@superdispatch/ui';
import { Alert, Button, TextBox } from '@superdispatch/ui-lab';
import { formatPlural } from 'shared/helpers/IntlHelpers';
import { useBoolean } from 'shared/hooks/useBoolean';
import { LoadSuggestionsDrawer } from 'shared/modules/load-suggestions/LoadSuggestionsDrawer';
import { useLoadSuggestionsUnseenCount } from 'shared/modules/load-suggestions/data/LoadSuggestionsAPI';
import styled from 'styled-components';

const Container = styled.div`
  & .MuiAlert-message {
    flex-grow: 1;
  }
`;

const AlertContent = styled.div`
  display: flex;
  gap: 16px;

  ${({ theme }) => theme.breakpoints.down('xs')} {
    flex-direction: column;
    align-items: stretch;
  }

  ${({ theme }) => theme.breakpoints.up('sm')} {
    align-items: center;
  }
`;

const LeftContent = styled.div`
  display: flex;
  gap: 8px;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    align-items: center;
  }
`;

const CountIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  width: 32px;
  height: 32px;
  border-radius: 50%;

  background-color: ${ColorDynamic.Blue300};
  color: ${ColorDynamic.White};
`;

const ButtonContainer = styled.div`
  ${({ theme }) => theme.breakpoints.up('sm')} {
    display: flex;
    align-items: center;
    flex-shrink: 0;

    margin-left: auto;
  }
`;

export const PostingsListSuggestionsOnRequestBanner = () => {
  const { data } = useLoadSuggestionsUnseenCount();
  const { isEnabled: isOpen, setTrue: open, setFalse: close } = useBoolean();

  if (
    !data?.number_of_unseen_suggestions ||
    data.number_of_unseen_suggestions === 0
  ) {
    return null;
  }

  return (
    <>
      <Container>
        <Alert severity="info" icon={false}>
          <AlertContent>
            <LeftContent>
              <CountIcon>
                <TextBox color="white" variant="body-semibold">
                  {data.number_of_unseen_suggestions}
                </TextBox>
              </CountIcon>

              <div>
                <TextBox variant="body-semibold">
                  Suggested{' '}
                  {formatPlural(
                    data.number_of_unseen_suggestions,
                    'load',
                    'loads',
                  )}{' '}
                  based on your request
                </TextBox>
                <TextBox>, including backhauls and along-route loads.</TextBox>
              </div>
            </LeftContent>

            <ButtonContainer>
              <Button variant="primary" fullWidth={true} onClick={open}>
                View Suggested Loads
              </Button>
            </ButtonContainer>
          </AlertContent>
        </Alert>
      </Container>

      <LoadSuggestionsDrawer
        open={isOpen}
        source="Request Based Nudging Banner"
        onClose={close}
      />
    </>
  );
};
